import axios from "axios";
import { useEffect, useState } from "react";
import 'remixicon/fonts/remixicon.css'
import sun from './img/clear.jpg';
import cloud from './img/cloud.jpg';
import rain from './img/rain.jpg';
import snow from './img/snow.jpg';
import fog from './img/fog.jpg';
import thunder from './img/thunder.jpg'


const WeatherDate = (d) => {
  const api = {
    key: '777ac3cc28d4cf9cb1e58d275f4fdc66',
    base: 'https://api.openweathermap.org/data/2.5/'
  }

  //숫자 앞에 0 붙이기
  const addZero = (value) => {
    if(value < 10){
      value = '0' + value;
    }
    return value;
  }

  //날짜
  let today = new Date();
  let year = today.getFullYear();
  let month = addZero(today.getMonth() + 1);
  let date = addZero(today.getDate());
  let day = today.getDay();
  let days = ["Sun", "Mon", "Tue", "Wed", "Tur", "Fri", "Sat"];
  let todays = `${year}. ${month}. ${date}. ${days[day]}`;

  //날씨
  const [city, setCity] = useState("Seoul");
  const url = `${api.base}weather?q=${city}&appid=${api.key}`;
  const [weather, setWeather] = useState("");

  //url에서 주는 날씨 정보 weather에 저장
  useEffect(() => {
    axios.get(url).then((res) => {
      const data = res.data;
      setWeather({
        id: data.weather[0].id, //아이콘
        temperature: data.main.temp, //화씨온도
        main: data.weather[0].main, //날씨정보
        loading: false,
      });
    })
  }, [url])


  return (
    <header>
      <p className="today">{todays}</p>
      <div className="main">
        <div className="weather left">
          <div>
            <h2 className="city">TODAY</h2>
            {weather.id === 800
              ? 
              <>
                <i className="ri-moon-clear-fill"></i>
                <p>
                  산책하기 딱 좋은 날씨에요<br/>
                  달빛 보면서 산책 어떠세요?
                </p>
              </>
              : null
            }
            {weather.id >= 200 && weather.id <= 232
              ? 
              <>
                <i className="ri-netflix-fill"></i>
                <p>
                  따뜻한 이불 속에서<br/>
                  넷플릭스 영화 한편 어떠세요?
                </p>
              </>
              : null
            }
            {weather.id >= 300 && weather.id <= 531
              ? 
              <>
                <i className="ri-umbrella-fill"></i>
                <p>
                  오늘은 비가 오는 날씨에요<br/>
                  우산 꼭 챙겨주세요!
                </p>
              </>
              : null
            }
            {weather.id >= 600 && weather.id <= 622
              ? 
              <>
                <i className="ri-shopping-bag-fill"></i>
                <p>
                  따뜻한 이불 속에서<br/>
                  인터넷 쇼핑 어떠세요?
                </p>
              </>
              : null
            }
            {weather.id >= 701 && weather.id <= 781
              ? 
              <>
                <i className="ri-surgical-mask-fill"></i>
                <p>
                  공기가 좋지 않아요<br/>
                  마스크를 꼭 챙겨주세요
                </p>
              </>
              : null
            }
            {weather.id >= 801 && weather.id <= 804
              ? 
              <>
                <i className="ri-bike-fill"></i>
                <p>
                  운동하기 딱 좋은 날씨에요<br/>
                  자전거 챙겨서 공원 어떠세요?
                </p>
              </>
              : null
            }
          </div>
        </div>
        <div className="weatherBack"></div>
      </div>
      <div className="main">
        <div className="weather">
          <div>
            <p className="city">{city}</p>
            <div className="weatherBox">
              <div className="icon">
                {weather.id === 800
                  ? <i className="ri-sun-fill"></i>
                  : null
                }
                {weather.id >= 200 && weather.id <= 232
                  ? <i className="ri-thunderstorms-fill"></i>
                  : null
                }
                {weather.id >= 300 && weather.id <= 321
                  ? <i className="ri-drizzle-fill"></i>
                  : null
                }
                {weather.id >= 500 && weather.id <= 531
                  ? <i className="ri-showers-fill"></i>
                  : null
                }
                {weather.id >= 600 && weather.id <= 622
                  ? <i className="ri-snowy-fill"></i>
                  : null
                }
                {weather.id >= 701 && weather.id <= 781
                  ? <i className="ri-sun-foggy-fill"></i>
                  : null
                }
                {weather.id >= 801 && weather.id <= 804
                  ? <i className="ri-cloudy-fill"></i>
                  : null
                }
              </div>
              <div className="ondo">{(weather.temperature - 273.15).toFixed(0)}˚</div>
            </div>
            <p className="text">
              {weather.id === 800
                ? '맑고 청명한 하늘이 예상됩니다'
                : null
              }
              {weather.id >= 200 && weather.id <= 232
                ? '천둥을 동반한 비가 예상됩니다'
                : null
              }
              {weather.id >= 300 && weather.id <= 321
                ? '약한 비가 예상됩니다'
                : null
              }
              {weather.id >= 500 && weather.id <= 531
                ? '많은 비가 예상됩니다'
                : null
              }
              {weather.id >= 600 && weather.id <= 622
                ? '날이 춥고, 눈이 예상됩니다'
                : null
              }
              {weather.id >= 701 && weather.id <= 781
                ? '안개가 예상됩니다 주의하세요'
                : null
              }
              {weather.id >= 801 && weather.id <= 804
                ? '구름이 많은 날이 예상됩니다'
                : null
              }
            </p>
          </div>
        </div>
        <div className="weatherBack"></div>
      </div>
      <div className="btn">
        <button 
          value="Seoul"
          onClick={(e) => setCity(e.target.value)}
        >Seoul
        </button>
        <button 
          value="Paris"
          onClick={(e) => setCity(e.target.value)}
        >Paris
        </button>
        <button 
          value="New York"
          onClick={(e) => setCity(e.target.value)}
        >New York
        </button>
        <button 
          value="Tokyo"
          onClick={(e) => setCity(e.target.value)}
        >Tokyo
        </button>
        <button 
          value="Londen"
          onClick={(e) => setCity(e.target.value)}
        >Londen
        </button>
        <button 
          value="Sydney"
          onClick={(e) => setCity(e.target.value)}
        >Sydney
        </button>
      </div>
      <div className="back">
        {weather.id === 800
          ? <img src={sun} alt="sun" />
          : null
        }
        {weather.id >= 200 && weather.id <= 232
          ? <img src={thunder} alt="cloud" />
          : null
        }
        {weather.id >= 300 && weather.id <= 531
          ? <img src={rain} alt="rain" />
          : null
        }
        {weather.id >= 600 && weather.id <= 622
          ? <img src={snow} alt="snow" />
          : null
        }
        {weather.id >= 701 && weather.id <= 781
          ? <img src={fog} alt="fog" />
          : null
        }
        {weather.id >= 801 && weather.id <= 804
          ? <img src={cloud} alt="cloud" />
          : null
        }
      </div>
    </header>
  );
}

export default WeatherDate;